/* i18n Init
 */
export const LANG_MAP = {
  // Lazy load, because "promise"
  en: () => import('../i18n/en.json'),
  ru: () => import('../i18n/ru.json'),
  de: () => import('../i18n/de.json'),
  it: () => import('../i18n/it.json'),
};

export const LANGS = Object.keys(LANG_MAP);

/*
 */
export const get_lang_bydomain = (): string => {
  const host = window.location.hostname;
  const subdomain = host.split('.')[0];
  return LANGS.includes(subdomain) ? subdomain : LANGS[0];
};

/*
 */
export const get_lang = (): string => {
  // Сначала проверяем URL-параметр
  const urlParams = new URLSearchParams(window.location.search);
  const langFromUrl = urlParams.get('lang');
  if (langFromUrl && LANGS.includes(langFromUrl)) {
    return langFromUrl;
  }
  // Затем проверяем поддомен
  return get_lang_bydomain();
};

/*
 */
export const init_i18n = async () => {
  const lang = get_lang();

  if (lang && Object.prototype.hasOwnProperty.call(LANG_MAP, lang)) {
    const module = await (LANG_MAP as Record<string, () => Promise<any>>)[
      lang
    ]();
    const translations = module.default || module;
    // Устанавливаем в оба ключа для совместимости
    (window as any)['__custom__locale__translations__'] = translations;
    (window as any)['__custom__locale__translations'] = translations;
    init_heplers();
    return translations;
  } else {
    return {};
  }
};

/*
 */
const init_heplers = () => {
  window.addEventListener('message', (event: any) => {
    if (event.data?.type === 'get_translations') {
      event.source?.postMessage(
        {
          type: 'translations',
          payload:
            (window as any)['__custom__locale__translations__'] ||
            (window as any)['__custom__locale__translations'],
        },
        event.origin
      );
    }
  });
};
